export default {
  "brand.name": "USFansLink",
  "nav.home": "Home",
  "nav.guide": "Spreadsheet Guide",
  "nav.shopping": "Shopping Guide",
  "nav.categories": "Categories",
  "nav.visit": "Visit Main Website",
  "lang.en": "English",
  "lang.pl": "Polski",
  "lang.es": "Español",
  "lang.fr": "Français",
  "footer.tagline": "An independent resource hub for the USFans Spreadsheet.",
  "footer.navTitle": "Explore",
  "footer.resourcesTitle": "Resources",
  "footer.disclaimerTitle": "Disclaimer",
  "footer.disclaimer": "USFansLink.asia is an independent informational resource. We are not affiliated with USFans or the main website. Always verify current information before making purchases or payments.",
  "footer.home": "Home",
  "footer.guide": "Spreadsheet Guide",
  "footer.mainSite": "Main Website",
  "footer.copyright": "© 2026 USFansLink.asia. All rights reserved.",
  "notfound.title": "Page Not Found",
  "notfound.body": "The page you are looking for does not exist or has been moved.",
  "notfound.home": "Back to Home",
};